import React, { useState, useEffect } from "react";
import "./HospitalScheduleCommonPopup.css";
import Swal from "sweetalert2";
import axios from "axios";
import { getServerBaseUrl } from "../../../../../utils/portConfig";

function HospitalScheduleRegisterPopup({ isOpen, onSave, onClose, scheduleDate, selectedRow }) {
  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1/schedule`;
  const token = localStorage.getItem("token");
  const [doctorCategory, setDoctorCategory] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState({});
  const [selectedWorkState, setSelectedWorkState] = useState({});

  useEffect(() => {
    if (isOpen) {
      getDocCategories();
      setSelectedDoctor("");
      setSelectedWorkState("");
    }
  }, [isOpen]);

  // 의사 이름을 가져오는 함수
  const getDocCategories = async () => {
    try {
      const response = await axios.get(`${API_SERVER_URL}/${selectedRow.id}/doctorList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // value, label로
      const categoriesData = response.data.map((item) => ({
        value: item.id,
        label: item.username,
      }));

      setDoctorCategory(categoriesData);
    } catch (error) {
      console.error("Doctor Category Fetch Error:", error);
      Swal.fire({
        title: "오류",
        text: "데이터를 가져오는 중 오류가 발생했습니다.",
        icon: "error",
        showConfirmButton: true,
      });
    }
  };

  // 등록하기
  const regDocSchedule = async () => {
    const saveDocData = {
      hospitalId: selectedRow.id,
      doctorId: selectedDoctor.value,
      doctorName: selectedDoctor.label,
      type: Number(selectedWorkState.value),
      schDt: scheduleDate,
      stdMonth: scheduleDate.match(/^\d{4}-\d{2}/)[0],
    };
    onSave(saveDocData);
  };

  // 의사 선택하는 selectbox
  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].getAttribute("aria-label");

    setSelectedDoctor({
      value: selectedValue,
      label: selectedLabel,
    });
  };

  // 업무유형 선택하는 selectbox
  const handleSelectWorkChange = (e) => {
    const selectedValue = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].getAttribute("aria-label");

    setSelectedWorkState({
      value: selectedValue,
      label: selectedLabel,
    });
  };

  return (
    isOpen && (
      <div className="manage-popup">
        <div className="manage-popup-content">
          <div className="manage-popup-header">
            <label>{scheduleDate} 당직ㆍ휴진 등록</label>
          </div>
          <div className="manage-popup-body">
            <div className="manage-choose-doctor">
              <label>원장님 선택</label>
              <select value={selectedDoctor.value} onChange={(e) => handleSelectChange(e)} style={{ marginLeft: "22px" }}>
                <option value="">선택 안함</option>
                {doctorCategory.map((category, index) => (
                  <option key={index} value={category.value} aria-label={category.label}>
                    {category.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="manage-choose-doctor">
              <label>업무유형 선택</label>
              <select value={selectedWorkState.value} onChange={(e) => handleSelectWorkChange(e)}>
                <option value="">선택 안함</option>
                <option value="0" aria-label="당직">
                  당직
                </option>
                <option value="1" aria-label="휴진">
                  휴진
                </option>
                <option value="2" aria-label="야간">
                  야간
                </option>
              </select>
            </div>
          </div>
          <div className="manage-popup-footer">
            <button className="book-button" onClick={regDocSchedule}>
              등록
            </button>
            <button onClick={onClose}>닫기</button>
          </div>
        </div>
      </div>
    )
  );
}

export default HospitalScheduleRegisterPopup;
